import { useRef, useState } from "react";
import { toast } from "sonner";
import { Upload, Loader2, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { resolveImg } from "@/lib/sections";

export const ImageField = ({ value, onChange, testId }) => {
  const { authedAxios } = useAuth();
  const inputRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) return toast.error("La imagen supera 5 MB");
    const fd = new FormData();
    fd.append("file", file);
    setLoading(true);
    try {
      const { data } = await authedAxios().post("/admin/upload", fd);
      onChange(data.url);
      toast.success("Imagen subida");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "No se pudo subir la imagen");
    } finally {
      setLoading(false);
      e.target.value = "";
    }
  };

  return (
    <div className="space-y-2">
      <div className="flex gap-2">
        <input
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          placeholder="https://… o sube un archivo"
          className="admin-input flex-1"
          data-testid={`${testId}-url`}
        />
        <button type="button" onClick={() => inputRef.current?.click()} disabled={loading} className="admin-btn" data-testid={`${testId}-upload-btn`}>
          {loading ? <Loader2 size={14} className="animate-spin" /> : <Upload size={14} />} Subir
        </button>
        <input ref={inputRef} type="file" accept="image/jpeg,image/png,image/webp,image/gif" className="hidden" onChange={upload} data-testid={`${testId}-file`} />
      </div>
      {value && (
        <div className="relative w-fit">
          <img src={resolveImg(value)} alt="" className="h-24 rounded-lg border border-slate-800 object-cover" data-testid={`${testId}-preview`} />
          <button type="button" onClick={() => onChange("")} className="absolute -right-2 -top-2 rounded-full bg-red-500 p-1 text-white" aria-label="Quitar imagen" data-testid={`${testId}-remove`}>
            <X size={12} />
          </button>
        </div>
      )}
    </div>
  );
};

export default ImageField;
